<div style="width: 320px;" class="col-outer">
  <section-card
    *ngIf="page?.section === conceptSections.REQUIREMENT; else altSection"
    [sections]="subsections"
    (selectedSectionIdChange)="redirectHandle($event)"
    [selectedSectionId]="page?.subsection === conceptSubSection.COMPARISON_TOOL ? conceptSubSection.RESULTS : page?.subsection ?? ''">

      <div class="h100 config-cont" [slot]="conceptSubSection.MAIN" [style.height]="maxHeight() - tabOffsetHeight - solveHeight +'px'">
        <app-treeview *ngIf="page?.section === conceptSections.REQUIREMENT  && page?.subsection === conceptSubSection.MAIN" type="requirement"></app-treeview>
      </div>
      <div class="h100 config-cont" [slot]="conceptSubSection.RESULTS" [style.height]="maxHeight() - tabOffsetHeight - solveHeight +'px'">
        <results-list
        *ngIf="page?.subsection === conceptSubSection.RESULTS || page?.subsection === conceptSubSection.COMPARISON_TOOL"
        [(selectedItems)]="selectedItems"
        [compareCheckboxesVisible]="compareCheckboxesVisible"
        (selectedJobDuration)="selectedJobDuration = $event">
      </results-list>
        <div *ngIf="cliVersion || selectedJobDuration" class="footer">
          <span *ngIf="cliVersion">Solver version: {{ cliVersion }}</span>
          <span *ngIf="cliVersion && selectedJobDuration"> | </span>
          <span *ngIf="selectedJobDuration">Duration: {{ selectedJobDuration }}</span>
        </div>

        @if (page?.subsection === conceptSubSection.RESULTS && (sectionSelectedAction?.urlParams?.[1]?.length === 36)) {
          <awc-button
            class="plr1rem download-details-btn"
            [type]="buttonType.SECONDARY"
            [text]="'Download Details'"
            (click)="onDownloadDetails()"
          ></awc-button>
        }

      <div *ngIf="page?.subsection === conceptSubSection.RESULTS && (sectionSelectedAction?.urlParams?.[1]?.length !== 36)" class="footer">
        <awc-button
          [text]="!compareCheckboxesVisible ? 'Compare' : 'Cancel'"
          [type]="buttonType.SECONDARY"
          [suffixIcon]="!compareCheckboxesVisible ? {icon: Icons.CHECKBOX_CHECKED} : undefined"
          (buttonClicked)="toggleCompareCheckboxes()"
          [ngClass]="{'shrink': compareCheckboxesVisible, 'expand': !compareCheckboxesVisible}"
        ></awc-button>
        <awc-button
          *ngIf="compareCheckboxesVisible"
          text="Go to Compare"
          [type]="selectedItems.length > 0 ? buttonType.PRIMARY : buttonType.SECONDARY"
          [disabled]="selectedItems.length < 1"
          [suffixIcon]="{icon: Icons.DISPLACEMENT}"
          (buttonClicked)="compareResults()"
          [@slideInFromRight]="'enter'"
        ></awc-button>
      </div>
      <div *ngIf="page?.subsection === conceptSubSection.COMPARISON_TOOL" class="footer">
        <awc-button
          [text]="selectSimilarButtonLabel"
          [disabled]="!canSelectAllSimilar"
          (buttonClicked)="selectAllSimilarResults()"
        ></awc-button>
      </div>
    </div>
  </section-card>
  <ng-container *ngIf="page?.section === conceptSections.REQUIREMENT">
    <div class="solver-button flex">
      <awc-button
        *ngIf="isDevMode"
        [text]="'Import Results File'"
        [suffixIcon]="{ icon: Icons.FILE }"
        [type]="buttonType.SECONDARY"
        [size]="buttonSize.LARGE"
        (buttonClicked)="loadLocalOutputFile()"></awc-button>
      <awc-button
        [text]="solveRequirementText.value"
        [type]="buttonType.PRIMARY"
        [size]="buttonSize.LARGE"
        [disabled]="solveRequirementText.loading"
        [suffixIcon]="{icon: solveRequirementText.icon}"
        (buttonClicked)="solveButtonClicked($event)"></awc-button>
    </div>
  </ng-container>
</div>

<ng-template #altSection>
  <awf-dashboard-panel [padding]="size._0x">
    <div class="panel-header">
      <ng-container [ngSwitch]="page?.section">
        <ng-container *ngSwitchCase="conceptSections.CONFIGURATIONS">
          <awc-icon  src="assets/icons/vehicle.svg" [size]="iconSize.MEDIUM"></awc-icon>
          <span>Vehicle Configurations</span>
        </ng-container>
        <ng-container *ngSwitchCase="conceptSections.COMPONENT">
          <awc-icon [icon]="icons.MODELER" [size]="iconSize.MEDIUM"></awc-icon>
          <span>Vehicle Components</span>
        </ng-container>
        <ng-container *ngSwitchCase="conceptSections.ARCHITECTURE">
          <awc-icon [icon]="icons.FORCE_ANGLE" [size]="iconSize.MEDIUM"></awc-icon>
          <span>Vehicle Architecture</span>
        </ng-container>
      </ng-container>
    </div>

    <div class="h100 config-cont" [style.height]="maxHeight() - tabOffsetHeight +'px'">
      <ng-container [ngSwitch]="page?.section">
        <app-treeview *ngSwitchCase="conceptSections.CONFIGURATIONS" type="configurations"></app-treeview>
        <app-treeview *ngSwitchCase="conceptSections.COMPONENT" type="component"></app-treeview>
        <ng-container *ngSwitchCase="conceptSections.ARCHITECTURE">
          <app-architecture-configurations></app-architecture-configurations>
        </ng-container>
      </ng-container>
    </div>
  </awf-dashboard-panel>
</ng-template>
